import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { Suspense } from "react";
import TopBar from "./TopBar";
import SnackBar from "../../layouts/SnackBar";
import StepperNavigation from "./StepperNavigation";
import VirLogoutBar from "src/components/VirLogoutBar/VirLogoutBar";
import VirExpireAlarm from "src/components/VirExpireAlarm/VirExpireAlarm";
import { useSelector } from "react-redux";
import AppLoading from "./AppLoading";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";
import BrandLoading from "./BrandLoading";
import getBrandFromUrl from "src/utils/getBrandFromUrl";

const DigitalVIRLayout = () => {
  const classes = useStyles();
  const location = useLocation(); // Get the current path
  const appLoading = useSelector((state) => state.vir?.athenaApp?.loading);
  const [searchParams] = useSearchParams();
  const athenaSource = useSelector((state) => state.vir.athenaSource.source);

  const source = searchParams.get("source") || athenaSource;
  const brand = getBrandFromUrl().toLowerCase();

  const showBrandLoading = appLoading && source === "sms";
  return (
    <div className={classes.root}>
      {source !== "app" && <TopBar />}
      <div className={`${classes.wrapper} ${source === "app" ? "" : classes.pdWeb}`}>
        <div className={classes.contentContainer}>
          <div>
            <SnackBar />
            {location.pathname !== "/vehicleincidents/landing-page" && (
              <>
                {source === "web" && <VirLogoutBar />}
                <VirExpireAlarm />
              </>
            )}
            {appLoading && source === "app" && <AppLoading />}
            {showBrandLoading && <BrandLoading brand={brand} />}
            <Outlet />
            <StepperNavigation />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalVIRLayout;
